import { render, staticRenderFns } from "./Events.html?vue&type=template&id=7a5e0c27&scoped=true&external"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.scss?vue&type=style&index=0&id=7a5e0c27&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5e0c27",
  null
  
)

export default component.exports